import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  headContainer: {
    marginBottom: theme.spacing(2),
  },
  chip: {
    position: 'absolute',
    top: theme.spacing(1),
    left: theme.spacing(1),
  },
  card: {
    marginRight: theme.spacing(1),
    position: 'relative',
    overflow: 'hidden',

    '& .MuiChip-root': {
      backgroundColor: theme.palette.background.paper,
      fontStyle: 'italic',

      '& .MuiIcon-root': {
        fontSize: 18,
      },
    },
  },
  cardHeight: {
    height: '100%',
  },
  titleText: {
    width: '100%',
    overflowX: 'scroll',
    wrap: 'nowrap',
  },
  flex: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));
